/* Copyright (c) 2026 Xperi. All Rights Reserved. */

// ─── Domain: Route & Screen Constants ───
export { LocationUrls } from "./LocationUrls";
export { ScreenControllerTypes } from "./ScreenControllerTypes";
export { urlToScreenName } from "./urlToScreenName";
export {
  SCREEN_DISPLAY_NAMES,
  urlToScreenDisplayName
} from "./urlToScreenDisplayName";
export { isPlayerHostingUrl } from "./playerHostingUrls";

// ─── Domain: Grid Focus Arithmetic ───
export {
  GridDirection,
  GridEdgeBehaviour,
  gridDirectionFromInputAction,
  gridRowCount,
  moveGridFocus,
  toGridIndex,
  toGridPosition
} from "./GridNavigation";
export type {
  TGridDirection,
  TGridEdgeBehaviour,
  TGridNavigationOptions,
  TGridPosition
} from "./GridNavigation";

// ─── Domain: Carousel Focus Arithmetic ───
export {
  moveCarouselTileLeft,
  moveCarouselTileRight,
  moveCarouselRowUp,
  moveCarouselRowDown
} from "./CarouselNavigation";
export type { TCarouselRowMove } from "./CarouselNavigation";

// ─── Domain: Types ───
export type {
  InputSource,
  InputEventType,
  PointerPosition,
  TInputEvent,
  InputInterceptor,
  ModalInputHandler,
  ScreenInputHandler,
  NavigationEngineConfig,
  InputMode,
  LongPressConfig
} from "./types";
export type { Platform } from "./types";

// ─── Domain: Interfaces ───
export type { IModalController } from "./interfaces/IModalController";
export type { IScreenController } from "./interfaces/IScreenController";
export type { INavigationEngine } from "./interfaces/INavigationEngine";

// ─── Data: Core Classes ───
export { PlatformKeyMapper } from "./PlatformKeyMapper";
export { PointerMapper } from "./PointerMapper";
export { InterceptorChain } from "./InterceptorChain";
export type { InterceptorErrorPolicy } from "./InterceptorChain";
export { ModalController } from "./ModalController";
export { ScreenController } from "./ScreenController";
export { ScreenRegistry } from "./ScreenRegistry";
export { NavigationEngine } from "./NavigationEngine";
export { EasInputGate } from "./EasInputGate";

// ─── Data: Interceptors ───
export {
  createDirectionalCodeInterceptor,
  createLoggerInterceptor,
  createRepeatGuardInterceptor,
  createLongPressInterceptor,
  createInputModeInterceptor,
  createScrollThrottleInterceptor,
  createSecretCodeInterceptor,
  createEasInputBlockInterceptor
} from "./interceptors";
export type { LongPressInterceptorHandle } from "./interceptors";

// ─── Data: Platform ───
export { detectPlatform, registerTizenKeys } from "./platform";
